import IDSContext, { setBaseZIndex, zIndexManager } from './Context';

export default IDSContext;
export { zIndexManager, setBaseZIndex };
